import { render, staticRenderFns } from "./tagView.vue?vue&type=template&id=89828846&scoped=true&"
import script from "./tagView.vue?vue&type=script&lang=js&"
export * from "./tagView.vue?vue&type=script&lang=js&"
import style0 from "./tagView.vue?vue&type=style&index=0&id=89828846&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89828846",
  null
  
)

export default component.exports